import React, { useRef, useState } from 'react';

export default function ContactForm() {
 const [status,setStatus]=useState('idle');
 const busy=useRef(false);
 async function submit(event) {
  event.preventDefault();
  if(busy.current) return;
  busy.current=true; setStatus('sending');
  const data=Object.fromEntries(new FormData(event.currentTarget));
  const host=window.location.hostname;
  const base=['localhost','127.0.0.1'].includes(host)?`http://${host}:8787`:'';
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 25000);
  try {
   const response=await fetch(`${base}/api/general-message`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data),signal:controller.signal});
   const payload=await response.json();
   if(!response.ok || payload.ok!==true) throw new Error('Submission failed');
   setStatus('sent');
  } catch { setStatus('error'); } finally { clearTimeout(timeout); busy.current=false; }
 }
 return <form className="contact-form" onSubmit={submit} aria-label="Contact Dale">
  {status==='sent'?<div className="contact-success" role="status"><span aria-hidden="true">✓</span><h3>Your message is on its way.</h3><p>Thank you. Dale will review your note and follow up using the contact details you provided.</p></div>:<>
   <label htmlFor="contact-name">Your name</label><input id="contact-name" name="name" autoComplete="name" required maxLength={120} />
   <label htmlFor="contact-email">Email</label><input id="contact-email" name="email" type="email" autoComplete="email" required maxLength={254} />
   <label htmlFor="contact-company">Company or website <span>(optional)</span></label><input id="contact-company" name="company" autoComplete="organization" maxLength={250} />
   <label htmlFor="contact-message">What would you like to explore?</label><textarea id="contact-message" name="message" rows="4" required maxLength={5000} />
   <div className="form-trap" aria-hidden="true"><label htmlFor="contact-website">Leave this field empty</label><input id="contact-website" name="website" tabIndex="-1" autoComplete="off" /></div>
   <p className="form-note">Your message and contact details are sent to Dale to respond to your inquiry. Please leave out confidential information. <a href="/privacy">How we handle your inquiry</a>.</p>
   <button className="primary-action" type="submit" disabled={status==='sending'}>{status==='sending'?'Sending…':'Send your message ↗'}</button>
   {status==='error'&&<p role="alert">We could not confirm delivery. Your message is still here. Please contact <a href="mailto:dale@chase-ai.com">dale@chase-ai.com</a> before resending if you are unsure whether it arrived.</p>}
  </>}
 </form>;
}
